import React from 'react'
import MesHeroSection from './MesHeroSection'
import WhyMes from './WhyMES'
import Faq from './FAQ'
import MesOperations from './MesOperations'
import WhatIsMes from './WhatIsMes'
import FeaturesSection from './MesFeatures'
import ContactForm from './ContactMes'
import MESFunctionality from './MESFunctionality'
import InforCapabilities from './MesKeyCapabilities'
import { Helmet } from 'react-helmet';

const MES = () => {
  return (
    <div>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>PTKCS Tech | Manufacturing Execution System (MES) Solutions – Real-Time Production Control</title>
        <meta 
          name="description" 
          content="PTKCS Tech offers comprehensive Manufacturing Execution System (MES) services to optimize production processes, enhance real-time visibility, and improve operational efficiency. Our MES solutions integrate seamlessly with existing ERP systems, providing actionable insights and enabling smarter decision-making on the shop floor." 
        />
        <meta 
          name="keywords" 
          content="Manufacturing Execution System, MES solutions, real-time production control, production optimization, operational efficiency, ERP integration, shop floor visibility, PTKCS Tech, MES consulting, manufacturing software solutions" 
        />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PTKCS Tech | Manufacturing Execution System (MES) Solutions – Real-Time Production Control" />
        <meta 
          property="og:description" 
          content="PTKCS Tech offers comprehensive Manufacturing Execution System (MES) services to optimize production processes, enhance real-time visibility, and improve operational efficiency. Our MES solutions integrate seamlessly with existing ERP systems, providing actionable insights and enabling smarter decision-making on the shop floor." 
        />
        <meta property="og:image" content="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/infographic2.png?updatedAt=1760003585804" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PTKCS Tech | Manufacturing Execution System (MES) Solutions – Real-Time Production Control" />
        <meta 
          name="twitter:description" 
          content="PTKCS Tech offers comprehensive Manufacturing Execution System (MES) services to optimize production processes, enhance real-time visibility, and improve operational efficiency. Our MES solutions integrate seamlessly with existing ERP systems, providing actionable insights and enabling smarter decision-making on the shop floor." 
        />
        <meta name="twitter:image" content="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/infographic2.png?updatedAt=1760003585804" />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PTKCS Tech" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


                    <section>
              <MesHeroSection/>
          </section>

          
          <section>
        <MESFunctionality/>
              
          </section>
          
          <section>
              
              <InforCapabilities/>
               </section>

          <section>
              
             <WhatIsMes/>
          </section>

          <section>
              <WhyMes/>
          </section>

         <section>
              <FeaturesSection/>
          </section>

          <section>
              <MesOperations/>
          </section>

          

           <section>
              <Faq/>
          </section>

          <section>
              <ContactForm/>
          </section>
    </div>
  )
}

export default MES
